<template>
    <div :class="contentClassObj">
        <div class="content" v-if="lesson.data && shouldLessonBeShowing">
            <div v-if="fullScreenState">
                <div class="full-screen-mode">
                    <div class="video-overlay">
                        <div v-if="lesson.data.video" class="videoWrapper">
                            <video class="video-js vjs-big-play-centered shiur-video" ref="videoplayerref"
                                   v-on:loadedmetadata="videoReady()"
                                   width="100%" controls data-setup="{}">
                                <source :src="lesson.data.video.url" type="video/mp4"/>
                                <p class="vjs-no-js">
                                    To view this video please enable JavaScript, and consider upgrading to a web
                                    browser
                                    that
                                    <a href="http://videojs.com/html5-video-support/" target="_blank">supports
                                        HTML5
                                        video</a>
                                </p>
                            </video>
                        </div>
                    </div>
                </div>
            </div>
            <template>
                <div class="media-section" v-if="!fullScreenState">
                    <div class="media-header-1">
                        <div class="media-header-1-left-section">
                            <div class="title">{{lesson.data.name | uppercase}}</div>
                        </div>
                        <div class="save-section">
                            <div class="save-to-favorites-section" v-on:click="onSaveToFavoritesClick()"
                                 :class="saveSectionClassObj">
                                <font-awesome-icon class="save-section-icon" :icon="[getIconPrefix, 'star']"/>
                                <span>{{saveToFavoritesText}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="media-header-2">
                        <div class="media-header-1-right-section">
                            <div class="masechet-sponsor" v-if="lesson.data.masechet && lesson.data.masechet.sponsor">
                                <span class="masechet-sponsor-header">{{l10nMasechetSponsor}}: </span>
                                <span>{{lesson.data.masechet.sponsor.name}}</span>
                                <br>
                                <span>{{lesson.data.masechet.sponsor.reason}}: </span>
                                <span>{{lesson.data.masechet.sponsor['dedication_name']}}</span>
                            </div>
                        </div>
                        <div class="day-sponsor" v-if="lesson.data.sponsor">
                            <span>{{l10nLessonSponsor}}: </span>
                            <span>{{lesson.data.sponsor.name}}</span>
                            <br>
                            <span>{{lesson.data.sponsor.reason}}: </span>
                            <span>{{lesson.data.sponsor['dedication_name']}}</span>
                        </div>
                        <div v-else class="no-sponsor">
                            <jabra-btn v-on:jbr-click="navigateToSponsorLesson()">
                                <span>{{l10nDonate}}/{{l10nSponsor}}</span>
                            </jabra-btn>
                        </div>
                    </div>
                    <div class="player-section">
                        <div v-if="lesson.data.video" class="videoWrapper">
                            <video class="video-js vjs-big-play-centered shiur-video" ref="videoplayerref"
                                   v-on:loadedmetadata="videoReady()"
                                   width="100%" controls data-setup="{}">
                                <source :src="lesson.data.video.url" type="video/mp4"/>
                                <p class="vjs-no-js">
                                    To view this video please enable JavaScript, and consider upgrading to a web browser
                                    that
                                    <a href="http://videojs.com/html5-video-support/" target="_blank">supports HTML5
                                        video</a>
                                </p>
                            </video>
                        </div>
                    </div>
                    <div class="player-footer">
                        <div class="download-section" v-if="lesson">
                            <jabra-download-section :lesson="lesson.data"></jabra-download-section>
                        </div>
                    </div>


                    <div class="lesson-navigation">
                        <div class="previous-shiur" v-bind:class="{'missing-shiur':!previousLesson.data}"
                             v-on:click="navigateToLesson(previousLesson.data?previousLesson.data.id:null)">
                            <div class="arrow">
                                <font-awesome-icon :icon="['fal', 'chevron-left']" size="2x"/>
                            </div>
                            <div class="text">
                                <span class="directional-text">{{l10nPreviousShiur}}</span>
                                <br>
                                <span class="daf-name">{{previousLesson.data?previousLesson.data.name:null}}</span>
                            </div>
                        </div>
                        <div class="next-shiur" v-bind:class="{'missing-shiur':!nextLesson.data}"
                             v-on:click="navigateToLesson(nextLesson.data?nextLesson.data.id:null)">
                            <div class="arrow">
                                <font-awesome-icon :icon="['fal', 'chevron-right']" size="2x"/>
                            </div>
                            <div class="text">
                                <span class="directional-text">{{l10nNextShiur}}</span>
                                <br>
                                <span class="daf-name">{{nextLesson.data?nextLesson.data.name:null}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="daf-section" :class="dafContainerClassObj">
                    <div class="daf-header-section">
                        <div class="purchase-daf-section" v-if="!this.fullScreenState">
                            <jabra-btn dark v-on:jbr-click="navigateToDigitalTalmudStore()">
                                <span>{{l10nLessonPurchaseButton}}</span>
                            </jabra-btn>
                        </div>
                        <div>
                            <div class="pdf-page-turning-container">
                                <div @click="pdfNextPage()" class="next-page-button" :class="nextDafClassObj">
                                    <span><font-awesome-icon :icon="['fal', 'arrow-left']"/></span>
                                </div>
                                <div class="current-pdf-page">
                                    <span>{{pdfPageWidget}}</span>
                                </div>
                                <div @click="pdfPreviousPage()" class="previous-page-button"
                                     :class="previousDafClassObj">
                                    <span><font-awesome-icon :icon="['fal', 'arrow-right']"/></span>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div class="full-screen-btn-container" v-on:click="toggleFullScreen()">
                                <span><font-awesome-icon :icon="['fal', 'arrows']"/></span>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div class="daf-container">
                            <pdf :src="pdfUrl" :page="lessonStoreModule.pdfInfo.pageNumber"></pdf>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import http from '../services/axios'
    // import lodash from '../services/lodash'
    import helpers from '../services/helpers'
    // import fscreen from '../services/fscreen'
    // import videojs from 'video.js'
    import pdf from '../services/pdf'
    import vanilla from '../services/vanilla'

    // import LessonFullscreen from './LessonFullscreen'

    import {
        LOADING_PRISTINE,
        LOADING_STARTED,
        LOADING_COMPLETED_SUCCESS,
        LOADING_COMPLETED_FAILURE,
        ADD_USER_EVENT,
        ACTION_HISTORY,
        ACTION_FAVORITE,
        SET_PRESELECTED_DAF,
        EVENT_CLOSE_LESSON_FULLSCREEN,
        LOAD_LESSON_PDF,
        SET_LESSON_VIDEO_CURRENT_TIME,
        SET_LESSON_VIDEO_IS_PAUSED,
        PREVIOUS_PDF_PAGE_IF_ABLE,
        NEXT_PDF_PAGE_IF_ABLE,
        GET_USER_FAVORITES,
        SET_SIGNUP_SHOW_STATE,
        ROUTE_STORE_ROOT,
    } from '../services/constants'

    export default {
        name: 'lesson-component',
        components: {
            // 'lesson-fullscreen': LessonFullscreen,
            pdf,
        },
        data: function () {
            return {
                lesson: {
                    state: LOADING_PRISTINE,
                    data: null,
                    error: null,
                },
                previousLesson: {
                    state: LOADING_PRISTINE,
                    data: null,
                    error: null,
                },
                nextLesson: {
                    state: LOADING_PRISTINE,
                    data: null,
                    error: null,
                },
                videoElm: null,
                LOADING_PRISTINE: LOADING_PRISTINE,
                LOADING_STARTED: LOADING_STARTED,
                LOADING_COMPLETED_SUCCESS: LOADING_COMPLETED_SUCCESS,
                LOADING_COMPLETED_FAILURE: LOADING_COMPLETED_FAILURE,
                EVENT_CLOSE_LESSON_FULLSCREEN: EVENT_CLOSE_LESSON_FULLSCREEN,
                fullScreenState: false,
            }
        },
        computed: {
            locale: function () {
                const currentLanguage = this.$store.state.languageModule.currentLanguage
                return currentLanguage ? currentLanguage.locale : null
            },
            user: function () {
                return this.$store.state.user.data
            },
            l10nDonate() {
                return this.l10nGetter('donate')
            },
            l10nSponsor() {
                return this.l10nGetter('sponsor')
            },
            l10nLessonSponsor() {
                return this.l10nGetter('lesson_sponsor')
            },
            l10nMasechetSponsor() {
                return this.l10nGetter('masechet_sponsor')
            },
            l10nSaveToFavorites() {
                return this.l10nGetter('save_to_favorites')
            },
            l10nSavedToFavorites() {
                return this.l10nGetter('saved_to_favorites')
            },
            l10nDownload() {
                return this.l10nGetter('download')
            },
            l10nLessonPurchaseButton() {
                return this.l10nGetter('lesson_purchase_button')
            },
            l10nPreviousShiur() {
                return this.l10nGetter('previous_shiur')
            },
            l10nNextShiur() {
                return this.l10nGetter('next_shiur')
            },
            pdfContainerRefName() {
                return 'pdf-container'
            },
            pdfUrl() {
                if (this.lesson.data && this.lesson.data.pdf) {
                    return this.lesson.data.pdf.url
                }
                return ''
            },
            lessonStoreModule() {
                return this.$store.state.lessonModule
            },
            isPdfLoadedSuccessfully() {
                return this.lessonStoreModule.pdfInfo.loadingState === LOADING_COMPLETED_SUCCESS
            },
            isLessonLoading() {
                return this.lesson.state === LOADING_STARTED
            },
            isLessonLoadedSuccess() {
                return this.lesson.state === LOADING_COMPLETED_SUCCESS
            },
            areEventsLoadedSuccessfully() {
                return this.$store.state.userModule.events.state === LOADING_COMPLETED_SUCCESS
            },
            areEventsLoading() {
                return this.$store.state.userModule.events.state === LOADING_STARTED
            },
            shouldLessonBeShowing() {
                if (this.user) {
                    return this.isLessonLoadedSuccess && this.areEventsLoadedSuccessfully
                }
                return this.isLessonLoadedSuccess
            },
            contentClassObj() {
                return {
                    'loading': this.isLessonLoading || this.areEventsLoading
                }
            },
            favoriteEvents() {
                return this.$store.getters[GET_USER_FAVORITES]
            },
            isLessonFavorite() {
                if (this.lesson.data) {
                    return this.favoriteEvents.some(event => {
                        return event.entryID === this.lesson.data.id
                    })
                }
                return false
            },
            getIconPrefix() {
                return this.isLessonFavorite ? 'fas' : 'fal'
            },
            saveSectionClassObj() {
                return {'favorite': this.isLessonFavorite}
            },
            saveToFavoritesText() {
                return this.isLessonFavorite ? this.l10nSavedToFavorites : this.l10nSaveToFavorites
            },
            pdfPageWidget() {
                return `${this.lessonStoreModule.pdfInfo.pageNumber}/${this.lessonStoreModule.pdfInfo.numPages}`
            },
            isThereANextDaf() {
                return this.lessonStoreModule.pdfInfo.pageNumber < this.lessonStoreModule.pdfInfo.numPages
            },
            isThereAPreviousDaf() {
                return this.lessonStoreModule.pdfInfo.pageNumber > 1
            },
            previousDafClassObj() {
                return {
                    'disabled': !this.isThereAPreviousDaf
                }
            },
            nextDafClassObj() {
                return {
                    'disabled': !this.isThereANextDaf
                }
            },
            dafContainerClassObj() {
                return {
                    'full-screen-mode': this.fullScreenState
                }
            }
            // videoPlayerWidth() {
            //     const c = this.videoElm
            //     const padding = 105
            //     let w = vanilla.window.innerWidth
            //     w /= 2
            //     w -= padding * 2
            //     return c ? Math.max(870, w) : c
            // },
            // videoPlayerWidthPX() {
            //     return this.videoPlayerWidth ? `${Math.round(this.videoPlayerWidth)}px` : null
            // },
            // videoPlayerHeight() {
            //     const ratio = 1.78
            //     return this.videoPlayerWidth / ratio
            // },
            // videoPlayerHeightPX() {
            //     return this.videoPlayerHeight ? `${Math.round(this.videoPlayerHeight)}px` : null
            // },
        },
        watch: {
            '$route'(to, from) {
                this.update()
            },
            user(newVal) {
                if (newVal) {
                    this.addHistoryEntry()
                }
            },
        },
        methods: {
            update: function () {
                if (this.user) {
                    this.addHistoryEntry()
                }
                this.getLesson()
            },
            // forceVideoElmRegistration() {
            //     let count = 0
            //     const cancelToken = setInterval(() => {
            //         console.log(`forceVideoElmRegistration() call #${count++}`)
            //         const c = this.$refs['videoplayerref']
            //
            //         if (c) {
            //             this.videoElm = c
            //             clearInterval(cancelToken)
            //         }
            //     }, 10)
            // },
            addHistoryEntry() {
                this.$store.dispatch(ADD_USER_EVENT, {
                    userID: this.user.id,
                    action: ACTION_HISTORY,
                    entryID: this.$route.params.id,
                });
            },
            getLesson: function () {
                this.lesson = {
                    state: LOADING_STARTED,
                    data: null,
                    error: null,
                };
                const config = {
                    params: {
                        language: this.locale
                    }
                }
                http.getDelivery(`entries/${this.$route.params.id}`, config).then(results => {
                    const mappedResult = helpers.mapEntry(results.data)
                    this.lesson = {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: mappedResult,
                        error: null,
                    };
                    if (mappedResult && mappedResult.name) {
                        vanilla.setDocumentTitle(`Jabrutouch - ${mappedResult.name}`)
                    }
                    if (this.lesson.data.pdf) {
                        this.pdfWork(this.lesson.data.pdf.url)
                    }

                    this.getPreviousLesson()
                    this.getNextLesson()
                }).catch(err => {
                    console.log(err)
                    this.lesson = {
                        state: LOADING_COMPLETED_FAILURE,
                        data: null,
                        error: err.message,
                    };
                })
            },
            getPreviousLesson: function () {
                this.previousLesson = {
                    state: LOADING_PRISTINE,
                    data: null,
                    error: null,
                }

                const config = {
                    params: {
                        language: this.locale,
                        'contentType': 'lesson',
                        'number': this.lesson.data.number - 1,
                    }
                }
                http.getDelivery('entries', config).then(results => {
                    const mappedResults = results.data.map(entry => {
                        return helpers.mapEntry(entry)
                    })
                    this.previousLesson = {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: mappedResults && mappedResults.length > 0 ? mappedResults[0] : null,
                        error: null,
                    };
                }).catch(err => {
                    console.log(err)
                    this.previousLesson = {
                        state: LOADING_COMPLETED_FAILURE,
                        data: null,
                        error: err.message,
                    };
                })
            },
            getNextLesson: function () {
                this.nextLesson = {
                    state: LOADING_PRISTINE,
                    data: null,
                    error: null,
                }

                const config = {
                    params: {
                        language: this.locale,
                        'contentType': 'lesson',
                        'number': this.lesson.data.number + 1,
                    }
                }
                http.getDelivery('entries', config).then(results => {
                    const mappedResults = results.data.map(entry => {
                        return helpers.mapEntry(entry)
                    })
                    this.nextLesson = {
                        state: LOADING_COMPLETED_SUCCESS,
                        data: mappedResults && mappedResults.length > 0 ? mappedResults[0] : null,
                        error: null,
                    };
                }).catch(err => {
                    console.log(err)
                    this.nextLesson = {
                        state: LOADING_COMPLETED_FAILURE,
                        data: null,
                        error: err.message,
                    };
                })
            },

            onCloseFullScreen() {
                this.fullScreenState = false
                const ref = this.$refs['videoplayerref']
                if (ref) {
                    ref.currentTime = this.lessonStoreModule.sharedVideoState.currentTime
                    if (!this.lessonStoreModule.sharedVideoState.paused) {
                        ref.play()
                    }
                }
            },
            videoReady() {
                const ref = this.$refs['videoplayerref']
                if (ref) {
                    ref.currentTime = this.lessonStoreModule.sharedVideoState.currentTime
                    if (!this.lessonStoreModule.sharedVideoState.paused) {
                        ref.play()
                    }
                }

            },
            toggleFullScreen() {
                this.fullScreenState = !this.fullScreenState

                const ref = this.$refs['videoplayerref']
                if (ref) {
                    this.$store.commit(SET_LESSON_VIDEO_CURRENT_TIME, ref.currentTime)
                    this.$store.commit(SET_LESSON_VIDEO_IS_PAUSED, ref.paused)
                }
                if (!ref.paused) {
                    ref.pause()
                }
            },
            closeFullScreen() {
                const ref = this.$refs['videoplayerref']
                if (ref) {
                    this.$store.commit(SET_LESSON_VIDEO_CURRENT_TIME, ref.currentTime)
                    this.$store.commit(SET_LESSON_VIDEO_IS_PAUSED, ref.paused)
                }
                this.fullScreenState = false
            },
            pdfWork(url) {
                this.$store.dispatch(LOAD_LESSON_PDF, url)
            },
            pdfNextPage() {
                this.$store.dispatch(NEXT_PDF_PAGE_IF_ABLE)
            },
            pdfPreviousPage() {
                this.$store.dispatch(PREVIOUS_PDF_PAGE_IF_ABLE)
            },
            navigateToLesson: function (id) {
                this.$router.push({name: 'lesson', params: {id: id.toString()}})
            },
            navigateToDigitalTalmudStore() {
                let defaultMasechetId = this.lesson.data.masechet.id
                this.$store.commit(SET_PRESELECTED_DAF, this.lesson.data.daf)
                // this.$router.push({name: 'storeDigitalTalmud', params: {masechetId: defaultMasechetId.toString()}})
                this.$router.push({name: ROUTE_STORE_ROOT})
            },
            navigateToSponsorLesson() {
                let defaultMasechetId = this.lesson.data.masechet.id
                // this.$router.push({name: 'dedicationDay', params: {masechetId: defaultMasechetId.toString()}})
                this.$router.push({
                    name: 'dedicationDay',
                    query: {
                        number: this.lesson.data.number
                    }
                })
            },
            onSaveToFavoritesClick() {
                if (!this.user) {
                    this.$store.commit(SET_SIGNUP_SHOW_STATE, true)
                } else {
                    if (!this.isLessonFavorite) {
                        const eventObj = {
                            userID: this.user.id,
                            action: ACTION_FAVORITE,
                            entryID: this.lesson.data.id,
                        }
                        const vPlayer = this.$refs['video-player']
                        if (vPlayer && vPlayer.currentTime !== 0) {
                            const content = {
                                lessonTimestamp: vPlayer.currentTime
                            }
                            eventObj.content = JSON.stringify(content)
                        }
                        this.$store.dispatch(ADD_USER_EVENT, eventObj);
                    }
                }
            },
            l10nGetter(key) {
                return helpers.uiTextGetter(this.$store, key)
            },
        },
        created: function () {
            this.update()
            // this.forceVideoElmRegistration()
        },
        mounted: function () {
            // this.videoElm = videojs(this.$refs['shiur-player'])
        }
    }
</script>

<style scoped lang="scss">
    @import "../scss/main";

    .loading {
        min-height: 700px;
    }

    .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        background: linear-gradient(0deg, rgba(220, 233, 239, 0.7), white 40%);
        /*padding: 70px 245px 130px;*/
    }

    @media screen and (min-width: 961px) {
        .content {
            flex-direction: row;
        }

    }

    .media-section, .daf-section {
        width: 50%;
    }

    .media-section {
        padding: 30px 105px 0;

    }

    .media-header-1 {
        display: flex;
        justify-content: space-between;
        @include font-abraham(26px, $font-color-blue, 400);
        padding: 10px 0;
        border-bottom: $grey-3 solid 1px;

        .media-header-1-right-section {
            display: flex;
        }

    }

    .media-header-2 {
        display: flex;
        justify-content: space-between;
        padding: 12px 0;
        @include font-abraham(12px, $font-color-lighter-blue, 300);

        .masechet-sponsor {
            line-height: 14px;
            margin: 0 22px 0 0;
        }

        .masechet-sponsor-header {
            font-weight: 400;
        }

        .day-sponsor {
            line-height: 14px;
            color: $grey-1;
        }

    }

    .action-section {
        cursor: pointer;
        display: flex;
        border-right: $grey-3 solid 1px;
        padding: 0 50px 0 0;
    }

    .play-icon {
        color: $font-color-blue;
        margin: 0 30px 0 0;
    }

    .shiur-title-section {
        @include font-abraham(26px, $font-color-blue, 400);
    }

    .shiur-length-section {
        display: flex;
        align-items: center;
        @include font-abraham(18px, $grey-1, 300);
    }

    .shiur-length-icon {
        margin: 0 12px 0 0;
    }

    .save-section {
        display: flex;
        align-items: center;
        @include font-abraham(14px, $font-color-lighter-blue, 300);
        line-height: 16px;
    }

    .save-to-favorites-section {
        cursor: pointer;
        &:hover {
            color: $accent-1;
        }
        &.favorite {
            color: $accent-1;
        }
        margin: 0 8px 0 0;
        span {
            margin: 6px;

        }
        display: flex;
    }

    .save-section-icon {
        font-size: 24px;
    }

    .player-section {
        .videoWrapper {
            position: relative;
            padding-bottom: 56.25%; /* 16:9 */
            height: 0;
        }
        .videoWrapper .video-js {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }

    .player-footer {
        display: flex;
        justify-content: space-between;
        border-bottom: $grey-3 solid 1px;
        padding: 25px 0;
    }

    .download-section {
        display: flex;
        align-items: center;
    }

    .purchase-daf-section {
        margin: 0 0 0 10px;
        padding: 10px;
    }

    .lesson-navigation {
        display: flex;
        justify-content: space-between;
        padding: 25px 0;
        .previous-shiur, .next-shiur {
            cursor: pointer;
            @include font-abraham(18px, $font-color-blue, 300);
            display: flex;
            align-items: center;
            .daf-name {
                font-size: 14px;
            }

            &.missing-shiur {
                cursor: not-allowed;
                @include font-abraham(18px, $grey-2, 300);
            }
        }
        .previous-shiur {
            flex-direction: row;
            .arrow {
                margin: 0 16px 0 0;
            }
        }
        .next-shiur {
            flex-direction: row-reverse;
            .arrow {
                margin: 0 0 0 16px;
            }
        }
        .arrow {
            color: $grey-3;
        }
    }

    .daf-section {
        display: flex;
        flex-direction: column;
        .daf-header-section {
            padding: 0 0 7px 0;
            display: flex;
            align-items: center;
        }

        &.full-screen-mode {
            width: 100%;

            .daf-header-section {
                justify-content: center;
            }
        }
    }

    .daf-container {
        height: calc(100vh - 225px);
        overflow: auto;
        border-left: $grey-3 solid 1px;
    }

    .full-screen-btn-container {
        background: $grey-3;
        color: $grey-2;
        font-size: 24px;
        padding: 9px;
    }

    .pdf-page-turning-container {
        margin: 0 10px;
        display: flex;
        background: $grey-3;
        color: $grey-2;
        @include font-abraham(16px, $grey-2, 300);
        .current-pdf-page, .previous-page-button, .next-page-button {
            padding: 11px;
            display: flex;
            align-items: center;
        }

        .current-pdf-page {
            padding: 11px 20px;
        }

        .previous-page-button, .next-page-button {
            cursor: pointer;
            font-size: 24px;

            &.disabled {
                color: lighten($grey-2, 20%);
                cursor: not-allowed;
            }
            span {
                display: flex;
                align-items: center;
            }
        }
    }

    .video-overlay {
        position: fixed;
        bottom: 10px;
        left: 10px;
        width: 400px;
        z-index: 1;
    }

    .videoWrapper {
        position: relative;
        padding-bottom: 56.25%; /* 16:9 */
        height: 0;
    }

    .videoWrapper .video-js {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }


</style>
